import React, { Component } from 'react';
import './PlayerPopup.css';
import './tabs.css';

import { round } from './Utils.js';
import {Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import MediaQuery from 'react-responsive';

import Popup from './Popup.js';
import GameView from './GameView.js';
import GameStatsGeneral from './GameStatsGeneral.js';
import GameStatsPlayerInfo from './GameStatsPlayerInfo.js';
import GameStatsKills from './GameStatsKills.js';
import GamesList from './GamesList.js';
import PlayerCharacterList from './PlayerCharacterList.js';

const filterData = require('./data/player_filter_data.json');

class PlayerPopup extends Component {
    static defaultProps = { i:1559 }; // singles 1567, doubles 1550

    constructor(props) {
        super(props);
        this.state = {gameIndex:0, tab:0, mini:true};
        this.selected = this.selected.bind(this);
        this.selectGame = this.selectGame.bind(this);
        this.allData = null;
    }

    componentDidMount() {
        let that = this;
        fetch("https://skydereign.github.io/forglory-data/player_data/" + this.props.i + ".json")
            .then(function(response) {
                if(!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(function(data) {
                that.allData = data;
                that.forceUpdate();
            }).catch(function(e) {
                that.allData = null;
            });
    }

    selected(character) {
        if (typeof this.props.selected === "function") {
            this.props.selected(character);
        }
    }

    selectGame(i) {
        if (this.state.mini) {
            this.setState({gameIndex:i, tab:1});
            
        } else {
            this.setState({gameIndex:i});
        }
    }


    render() {
        let data = this.allData;

        if (data === null) {
            return (
            <Popup close={this.props.close} fill={true}>
              <div className="PlayerPopup">
                <div className="topbar">
                  <img className="mii" src={"https://skydereign.github.io/forglory-data/miis/" + this.props.i + ".png"} alt={this.props.i} />
                  <div className="win-rate">
                    <img className="mii-name" src={"https://skydereign.github.io/forglory-data/names/" + this.props.i + ".png"} alt={this.props.i} />
                  </div>
                  <PlayerCharacterList />
                </div>
                <div className="body">
                  <GamesList />
                  <div className="game-view">
                    <h2>No Game Data</h2>
                  </div>
                </div>                
              </div>
            </Popup>
            );
        }
        
        let gI = this.state.gameIndex;
        let setCount = [0, 0, 'NA'];
        
        for (let i=0; i<data.length; i++) {
            if (data[i]["won"]) {
                setCount[0]++;
            } else if(!data[i]["dc"]) {
                setCount[1]++;
            }
        }

        if (setCount[0] > 0 || setCount[1] > 0) {
            setCount[2] = 100.0 * setCount[1] / (setCount[0] + setCount[1]);
        }


        return (
            <Popup close={this.props.close} fill={true}>
              <div className="PlayerPopup">
                <MediaQuery maxWidth={600}>
                  <div className="topbar-mini">
                    <img className="mii" src={"https://skydereign.github.io/forglory-data/miis/" + this.props.i + ".png"} alt={this.props.i} />
                    <div className="win-rate-mini">
                      <img className="mii-name" src={"https://skydereign.github.io/forglory-data/names/" + this.props.i + ".png"} alt={this.props.i} />
                      <h2>{setCount[1]} - {setCount[0]} ({round(setCount[2], 2)}%)</h2>
                    </div>
                  </div>
                </MediaQuery>
                
                <MediaQuery minWidth={600}>
                  <div className="topbar">
                    <img className="mii" src={"https://skydereign.github.io/forglory-data/miis/" + this.props.i + ".png"} alt={this.props.i} />
                    <div className="win-rate">
                      <img className="mii-name" src={"https://skydereign.github.io/forglory-data/names/" + this.props.i + ".png"} alt={this.props.i} />
                      <h2>{setCount[1]} - {setCount[0]} ({round(setCount[2], 2)}%)</h2>
                    </div>
                    <PlayerCharacterList data={filterData[this.props.i]} />
                  </div>
                </MediaQuery>
                
                <MediaQuery maxWidth={1300}>
                  <Tabs selectedIndex={this.state.tab} onSelect={tab => this.setState({ tab })}>
                    <TabList>
                      <Tab>Games</Tab>
                      <Tab>Game Data</Tab>
                      <Tab>Kills</Tab>
                      <Tab>Percent Graph</Tab>
                    </TabList>
                    
                    <TabPanel>
                      <GamesList data={data} focused={this.state.gameIndex} selectGame={this.selectGame}/>
                    </TabPanel>
                    <TabPanel>
                      <GameStatsGeneral data={data[gI]} />
                    </TabPanel>
                    <TabPanel>
                      { data[gI]["has_percent_data"] &&
                          <GameStatsPlayerInfo data={data[gI]} /> && 
                              <GameStatsKills data={data[gI]} />
                              }
                    </TabPanel>
                    <TabPanel>
                      { data[gI]["has_percent_data"] && 
                          <div className="percent-container">
                                <GameView yGrid={165} gameData={data[gI]} flipPortraits={true} />
                              </div>
                          }
                    </TabPanel>
                  </Tabs>
                </MediaQuery>
                <MediaQuery minWidth={1300}>            
                  <div className="body">
                    <GamesList data={data} focused={this.state.gameIndex} selectGame={this.selectGame}/>
                    <div className="game-view">
                      <div className="game-stats">
                        <GameStatsGeneral data={data[gI]} />
                        
                        { data[gI]["has_percent_data"] &&
                            <GameStatsPlayerInfo data={data[gI]} /> && 
                                <GameStatsKills data={data[gI]} />
                                }
                      </div>
                      { data[gI]["has_percent_data"] && 
                          <div className="percent-container">
                                <GameView yGrid={165} gameData={data[gI]} flipPortraits={true} />
                              </div>
                          }
                    </div>
                  </div>
                </MediaQuery>
              </div>
            </Popup>
        );
    }
}

export default PlayerPopup;
